import React from 'react';
import PropTypes from 'prop-types';

function FacebookIcon({ color, width, height }) {
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* eslint-disable-next-line max-len */}
      <path d="M3.25317 19.5036C3.25508 27.4976 9.06809 34.3042 16.9634 35.5569V24.1998H12.8407V19.5036H16.9683V15.9286C16.7837 14.2346 17.3623 12.5463 18.5471 11.3217C19.7319 10.097 21.4001 9.46278 23.0994 9.59112C24.3189 9.61084 25.5354 9.71945 26.7394 9.91614V13.912H24.6854C23.9782 13.8194 23.2672 14.0529 22.7528 14.5468C22.2383 15.0408 21.976 15.7416 22.0399 16.4518V19.5036H26.5428L25.8229 24.2014H22.0399V35.5569C30.5783 34.2075 36.5658 26.4095 35.6647 17.8121C34.7635 9.21473 27.289 2.82776 18.6563 3.27829C10.0235 3.72882 3.25456 10.8591 3.25317 19.5036Z" fill={color} />
    </svg>
  );
}

FacebookIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};

FacebookIcon.defaultProps = {
  color: '#7ED321',
  width: '39',
  height: '39',
};

export default React.memo(FacebookIcon);
